export const passwRegex = /^.{8,}$/;
export const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const phoneRegex = /^05\d([-]{0,1})\d{7}$/;
export const phoneGlobalRegex = /^9725\d([-]{0,1})\d{7}$/;
export const phoneSlicedRegex = /^5\d([-]{0,1})\d{7}$/;
export const internationalPhoneRegex = /^(?:\+|00)?\d{7,15}$|^05\d{8}$/;
export const checkSpecialSign = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
export const uppercaseRegex = /\p{Lu}/u;
export const onlyDigitsRegex = /^\d+$/;
export const varsRegular = /{{(\d+)}}/g;
export const varEndRegular = /{{\d+}}$/;
